import {
  type AnyStatsigOptions,
  type NetworkArgs,
  SDKType,
  StatsigMetadataProvider,
} from '@statsig/react-bindings'

import { applyAppStateVisibilityShim } from './appVisibilityShim'
import { createPreloadedAsyncStorage } from './preloadedAsyncStorage'

// Vendored from @statsig/react-native-core's RNSetup. Wires the RN platform
// concerns into a StatsigOptions before the client is constructed: the AppState
// visibility shim, the binding type, the AsyncStorage-backed storage provider
// (unless the host supplied its own), and a fetch-based network override that
// sets the JSON content-type header.

export function setupStatsigForReactNative(
  statsigMetadataAdditions: Record<string, string | undefined> | null,
  options: AnyStatsigOptions,
): void {
  applyAppStateVisibilityShim()

  SDKType._setBindingType('rn')
  if (statsigMetadataAdditions) {
    StatsigMetadataProvider.add(statsigMetadataAdditions)
  }

  if (options.storageProvider == null) {
    options.storageProvider = createPreloadedAsyncStorage()
  }

  applyNetworkFix(options)
}

function applyNetworkFix(options: AnyStatsigOptions) {
  if (options.networkConfig?.networkOverrideFunc != null) {
    return
  }

  const networkOverrideFunc = (url: string, args: NetworkArgs) => {
    if (args.body != null && args.method === 'POST') {
      args.headers = {
        'Content-Type': 'application/json',
        ...args.headers,
      }
    }
    return fetch(url, args)
  }

  options.networkConfig = {
    networkOverrideFunc,
    ...options.networkConfig,
  }
}
